/*
    Add here your own custom javascript
*/

// Fix for the RTL language in the demo
document.querySelectorAll('[href="/ar"]').forEach(link => {
    link.setAttribute('target', '_blank')
})

/*
    =============================================
    Quick-Shop Modal for multi-variant products
    =============================================
    Opens a stylish modal when "Add to Cart" is clicked on a product card
    with multiple variants. Single-variant products add directly to cart.
*/
;(function () {

    const modal = document.getElementById('quick-shop-modal')
    if (!modal) return

    const bsModal       = bootstrap.Modal.getOrCreateInstance(modal)
    const modalImg      = modal.querySelector('#quick-shop-img')
    const modalTitle    = modal.querySelector('#quick-shop-title-link')
    const modalPrice    = modal.querySelector('#quick-shop-price')
    const modalOptions  = modal.querySelector('#quick-shop-options')
    const modalForm     = modal.querySelector('#quick-shop-form')
    const modalViewLink = modal.querySelector('#quick-shop-view-link')

    let currentVariants = []
    let currentOptions  = []
    let currentSelected = {}
    let itemWasAdded    = false

    // Smooth image transition on load
    modalImg.addEventListener('load', () => {
        modalImg.classList.remove('switching')
    })

    // ---- Event delegation: any .btn-quick-shop click opens the modal ----
    document.addEventListener('click', (e) => {
        const btn = e.target.closest('.btn-quick-shop')
        if (!btn) return

        e.preventDefault()
        e.stopPropagation()

        const title    = btn.dataset.productTitle
        const url      = btn.dataset.productUrl
        const img      = btn.dataset.productImg
        const imgAlt   = btn.dataset.productImgAlt || title
        const variants = JSON.parse(btn.dataset.productVariants)
        const options  = JSON.parse(btn.dataset.productOptions)

        currentVariants = variants
        currentOptions  = options
        currentSelected = {}
        itemWasAdded    = false

        // Populate static content
        modalTitle.textContent = title
        modalTitle.href        = url
        modalImg.src           = img
        modalImg.alt           = imgAlt
        modalViewLink.href     = url

        // Set form tracking attrs (Klaviyo in onSubmitAtcForm)
        modalForm.dataset.productTitle = title
        modalForm.dataset.productUrl   = url

        // Build option buttons
        buildOptionButtons(options, variants)

        // Select first available variant
        const firstAvailable = variants.find(v => v.available) || variants[0]
        selectVariant(firstAvailable)

        bsModal.show()
    })

    // ---- Build grouped option buttons ----
    function buildOptionButtons (options) {
        modalOptions.innerHTML = ''

        options.forEach((option, optionIndex) => {
            // Label
            const label = document.createElement('p')
            label.className = 'quick-shop-option-label fw-bold mb-2 small text-uppercase'
            label.textContent = option.name
            modalOptions.appendChild(label)

            // Button group
            const group = document.createElement('div')
            group.className = 'quick-shop-option-group d-flex flex-wrap gap-2 mb-3'
            group.dataset.optionIndex = optionIndex

            option.values.forEach(value => {
                const optBtn = document.createElement('button')
                optBtn.type      = 'button'
                optBtn.className = 'btn btn-outline-dark quick-shop-opt-btn'
                optBtn.textContent = value
                optBtn.dataset.optionName  = option.name
                optBtn.dataset.optionValue = value
                optBtn.dataset.optionIndex = optionIndex

                optBtn.addEventListener('click', () => {
                    currentSelected[option.name] = value

                    // Active state within group
                    group.querySelectorAll('.quick-shop-opt-btn').forEach(b => b.classList.remove('active'))
                    optBtn.classList.add('active')

                    const match = findMatchingVariant()
                    if (match) selectVariant(match)
                })

                group.appendChild(optBtn)
            })

            modalOptions.appendChild(group)
        })
    }

    // ---- Find variant matching current selections ----
    function findMatchingVariant () {
        return currentVariants.find(variant => {
            return currentOptions.every((opt, i) => {
                const selected = currentSelected[opt.name]
                return !selected || selected === variant.options[i]
            })
        })
    }

    // ---- Select a variant: update image, price, button, form input ----
    function selectVariant (variant) {
        // Update currentSelected from this variant
        currentOptions.forEach((opt, i) => {
            currentSelected[opt.name] = variant.options[i]
        })

        // Highlight active buttons
        modalOptions.querySelectorAll('.quick-shop-opt-btn').forEach(btn => {
            const isActive = currentSelected[btn.dataset.optionName] === btn.dataset.optionValue
            btn.classList.toggle('active', isActive)
        })

        // Update image if variant has one
        if (variant.featured_image && variant.featured_image.src) {
            modalImg.classList.add('switching')
            modalImg.src = variant.featured_image.src
        }

        // Update price
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            modalPrice.innerHTML =
                '<span class="text-muted me-2"><s>' + Shopify.formatMoney(variant.compare_at_price) + '</s></span>' +
                '<span class="fw-bold">' + Shopify.formatMoney(variant.price) + '</span>'
        } else {
            modalPrice.innerHTML =
                '<span class="fw-bold">' + Shopify.formatMoney(variant.price) + '</span>'
        }

        // Update hidden input
        modalForm.querySelector('[name="id"]').value = variant.id

        // Button state
        const atcBtn = modalForm.querySelector('.btn-atc')
        if (variant.available) {
            atcBtn.disabled = false
            atcBtn.textContent = atcBtn.dataset.textAddToCart
        } else {
            atcBtn.disabled = true
            atcBtn.textContent = window.theme.product.soldOut
        }

        updateOptionAvailability()
    }

    // ---- Grey out option combos with no available variant ----
    function updateOptionAvailability () {
        modalOptions.querySelectorAll('.quick-shop-opt-btn').forEach(btn => {
            const testSelected = Object.assign({}, currentSelected)
            testSelected[btn.dataset.optionName] = btn.dataset.optionValue

            const hasAvailable = currentVariants.some(variant => {
                if (!variant.available) return false
                return currentOptions.every((opt, i) => {
                    const sel = testSelected[opt.name]
                    return !sel || sel === variant.options[i]
                })
            })

            btn.classList.toggle('unavailable', !hasAvailable)
        })
    }

    // ---- Track successful add-to-cart inside the modal ----
    // product.js line 34 skips opening offcanvas when form is inside .modal,
    // so we listen for the cart-updated event to know an item was added.
    // Auto-close the modal after a brief pause so the offcanvas cart opens.
    window.addEventListener('updated.ecomify.cart', () => {
        if (modal.classList.contains('show')) {
            itemWasAdded = true
            setTimeout(() => { bsModal.hide() }, 800)
        }
    })

    // ---- After modal closes, open offcanvas cart if item was added ----
    // Mirrors the upsell-modal pattern in product.js
    modal.addEventListener('hidden.bs.modal', () => {
        if (itemWasAdded) {
            itemWasAdded = false
            if (document.querySelector('#offcanvas-cart')) {
                bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show()
            }
        }
        // Always reset button text for next open
        const atcBtn = modalForm.querySelector('.btn-atc')
        atcBtn.textContent = atcBtn.dataset.textAddToCart
    })

})()

// EcomGraduates - Affiliate tracking code
function addRefParamToUrlsAndSetCookie () {
    const urlParams = new URLSearchParams(window.location.search)
    let refParam = urlParams.get('ref')

    if (!refParam) {
        // Check if the "ref" cookie exists
        const cookies = document.cookie.split(';')
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim()
            if (cookie.startsWith('ref=')) {
                refParam = cookie.substring(4)

                urlParams.set('ref', refParam)
                break
            }
        }
    }

    if (refParam) {
    // Set the "ref" cookie with the "ref" parameter value
        document.cookie = `ref=${refParam}; expires=${new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)}; path=/`

        // Update the URLs on the page with the "ref" parameter value
        const links = document.getElementsByTagName('a')
        for (let i = 0; i < links.length; i++) {
            const link = links[i]
            const url = new URL(link.href)
            if (url.hostname === 'ecomgraduates.com') {
                if (url.search) {
                    url.search += `&ref=${refParam}`
                } else {
                    url.search = `?ref=${refParam}`
                }
                link.href = url.href
            }
        }
    }
}
// addRefParamToUrlsAndSetCookie()
